import React from 'react';

export function isType(element, typeName) {
    if (!element || !element.type) {
        return false;
    }
    if (element.type && !element.type.name) {
        return element.type === typeName;
    }
    return element.type.name === typeName;
}

export function getType(element) {
    if (!element || !element.type) {
        return undefined;
    }
    if (element.type && !element.type.name) {
        return element.type;
    }
    return element.type.name;
}

export function flattenHTMLChildren(children, existing) {
    // there are subtle differences in the way live HTMLCollections are handled
    // compared to React children props.
    const ch = [...children];

    const container = existing ?? [];

    ch.forEach((child) => {
        if (child.children) {
            container.push(child);

            // let's make sure the parent element is in the right order within the array.
            return flattenHTMLChildren(child.children, container);
        }

        // we've hit the end of the branch - plain old html element
        return container.push(child);
    });

    return container;
}

export function flattenChildren(children, existing) {
    // Make sure that children passed in is an array so we can query it
    const ch = !Array.isArray(children) ? React.Children.toArray(children) : children;

    const container = existing ?? [];

    ch.forEach((child) => {
        if (React.isValidElement(child) && child.props.children) {
            // elements loses their props when we add it to an array? - not sure why this happens...
            const newChild = React.cloneElement(child, { ...child.props });

            container.push(newChild);

            // let's make sure the parent element is in the right order within the array.
            return flattenChildren(child.props.children, container);
        }

        // we've hit the end of the branch - plain old html element
        return container.push(child);
    });

    return container;
}

export function hasProp(element, prop) {
    if (!element.props) {
        return false;
    }

    return element.props[prop];
}

export default {
    flattenChildren,
    getType,
    isType,
    hasProp,
};
